/* Mobile navigation: one scrollable panel, predictable close and keyboard focus. */
(() => {
  const wide = window.matchMedia('(min-width: 1100px)');
  const close = (menu, restore = true) => {
    menu.open = false;
    document.documentElement.classList.remove('ob-menu-open');
    if (restore) menu.querySelector('summary').focus();
  };
  const setup = () => {
    const header = document.querySelector('.ob-topbar');
    if (header && !header.obSizeObserver && window.ResizeObserver) {
      header.obSizeObserver = new ResizeObserver(() => {
        document.body.style.setProperty('--ob-top', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      });
      header.obSizeObserver.observe(header);
    }
  };
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!menu.matches?.('.ob-mobile-menu')) return;
    document.documentElement.classList.toggle('ob-menu-open', menu.open);
    menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
    if (menu.open) menu.querySelector('.ob-mobile-nav [data-close-menu]').focus();
  }, true);
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.ob-mobile-menu');
    if (!menu) return;
    if (event.target.closest('[data-close-menu]')) close(menu);
    else if (event.target.closest('a[href]')) close(menu, false);
  });
  document.addEventListener('keydown', (event) => {
    const menu = document.querySelector('.ob-mobile-menu[open]');
    if (!menu) return;
    if (event.key === 'Escape') { event.preventDefault(); close(menu); }
    if (event.key !== 'Tab') return;
    const nodes = [...menu.querySelectorAll('summary, .ob-mobile-nav a[href], .ob-mobile-nav button:not(:disabled)')]
      .filter(node => !node.closest('[hidden]') && node.getClientRects().length);
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  wide.addEventListener('change', (event) => {
    const menu = document.querySelector('.ob-mobile-menu[open]');
    if (event.matches && menu) close(menu, false);
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

/* Each brand browser is independent, including editor section replacements. */
if (!customElements.get('ob-brand-browser')) {
  customElements.define('ob-brand-browser', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const input = this.querySelector('[data-brand-search]');
      const items = [...this.querySelectorAll('[data-brand-item]')];
      const count = this.querySelector('[data-brand-count]');
      if (count) count.textContent = String(items.length);
      const empty = this.querySelector('.ob-brand-empty');
      const disclosure = this.querySelector('details');
      const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
      const filter = () => {
        const query = normalize(input.value);
        let matches = 0;
        items.forEach((item) => {
          item.hidden = !normalize(item.dataset.brandName).includes(query);
          if (!item.hidden) matches++;
        });
        empty.hidden = matches > 0;
      };
      input.addEventListener('input', filter, options);
      input.addEventListener('search', filter, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        if (input.value) {
          input.value = '';
          filter();
        } else {
          disclosure.open = false;
          disclosure.querySelector('summary').focus();
        }
      }, options);
      if (this.hasAttribute('data-responsive')) {
        const wide = window.matchMedia('(min-width: 1200px)');
        let collapsed = false;
        try { collapsed = sessionStorage.getItem('ob-brands-collapsed') === 'true'; } catch (_) {}
        disclosure.open = (wide.matches && !collapsed) || window.location.hash === '#ob-brand-panel';
        disclosure.addEventListener('toggle', () => {
          if (wide.matches) { try { sessionStorage.setItem('ob-brands-collapsed', String(!disclosure.open)); } catch (_) {} }
        }, options);
        wide.addEventListener('change', (event) => { disclosure.open = event.matches; }, options);
      }
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

/* Brands uses the catalogue panel instead of a second list in the main menu. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-open-brands]');
  const panel = document.getElementById('ob-brand-panel');
  if (!link || !panel || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  const menu = link.closest('.ob-mobile-menu');
  if (menu) menu.open = false;
  panel.querySelector('details').open = true;
  panel.querySelector('[data-brand-search]').focus();
});

/* Delegation also handles product cards inserted by filtering and homepage loading. */
document.addEventListener('click', event => {
  const button = event.target.closest('[data-quantity-step]');
  if (!button) return;
  const input = button.closest('[data-card-quantity]')?.querySelector('input');
  const submit = button.closest('form')?.querySelector('[name="add"]');
  if (!input || input.disabled || submit?.disabled || submit?.getAttribute('aria-disabled') === 'true') return;
  const min = Number(input.min) || 1, step = Number(input.step) || 1;
  const max = input.max === '' ? Infinity : Number(input.max);
  let value = Number(input.value);
  if (!Number.isFinite(value) || input.value === '') value = min;
  if (button.dataset.quantityStep === 'up') value = min + (Math.floor((value - min) / step) + 1) * step;
  else value = min + (Math.ceil((value - min) / step) - 1) * step;
  const last = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
  input.value = Math.max(min, Math.min(last, value));
  input.dispatchEvent(new Event('input', {bubbles:true}));
  input.dispatchEvent(new Event('change', {bubbles:true}));
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.ob-category-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
document.addEventListener('click', event => {
  document.querySelectorAll('.ob-category-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});
